import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { getDisplayTextLabelText } from '@vista-digital/occ-domain';
import { observer } from 'mobx-react';
const bWrapper = bemClassBuilder('v-text-area-wrapper');
const b = bemClassBuilder('v-text-area');
/**
 * Renders a textarea component.
 */
export const TextArea = observer(props => {
    const { id, name, rows, columns, value, placeholder, style, className, disabled, helpTextId, onBlur, onFocus, onKeyPress, label, textAreaRef } = props;
    const handleChange = event => {
        const { onChange, onChangeValue } = props;
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        onChangeValue === null || onChangeValue === void 0 ? void 0 : onChangeValue(event.target.value);
    };
    return (_jsxs("div", { className: bWrapper.block({ hasValue: !!value }), children: [props.children, _jsx("textarea", { ref: textAreaRef, className: b.block({ style: style }, className), id: id, name: name, rows: rows, cols: columns, maxLength: props.maxLength, value: value, placeholder: placeholder || undefined, disabled: disabled, "aria-describedby": helpTextId, "aria-label": label ? getDisplayTextLabelText(label) : undefined, onChange: handleChange, onKeyPress: onKeyPress, onFocus: onFocus, onBlur: onBlur })] }));
});
TextArea.displayName = 'TextArea';
//# sourceMappingURL=text-area.js.map